import { Module } from '../../../Module';
import { GetSiteNamesRequest, IGetSiteNamesResult } from '../../../ServerApi/requests/GetSiteNamesRequest';
import { ISiteNameWithId } from '../../../ServerApi/types/ISiteNameWithId';
import { Resource } from '../../../resources/Resource';
import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';

export class SiteNameWithIds extends Resource<ISiteNameWithId> {

  public static readonly instance = new SiteNameWithIds(new WebClientListResourceFetcher(GetSiteNamesRequest, (result: IGetSiteNamesResult) => {
    return result.siteNames;
  }));

}
